module.exports = __webpack_public_path__ + "img/ring_r_o_0_null.f6407813.png";